import { useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";

import QnaInquiry from "./QnaInquiry";
import styles from "./QnaArticle.module.css";
import Header from "Page/common/components/Header";
import LinkBtn from "Page/common/components/LinkBtn";
import FileList from "Page/common/components/FileList";

export default function QnaArticle() {
  const { article_id } = useParams();
  let [data, setData] = useState({});
  let [password, setPassword] = useState(0);
  let [isAuthorized, setIsAutorized] = useState(false);

  const handleInputPw = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    if (e !== undefined) {
      e.preventDefault();
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/support/qna/article/${article_id}`,
        { password }
      );

      if (response.status == 200) {
        autoauto();
        setData(response.data[0]);
      }
    } catch (error) {
      //console.error("error:", error);
      if (error.response.status == 401) {
        alert("wrong pw!");
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const autoauto = () => {
    setIsAutorized(true);
  };

  return (
    <div className={styles.QnaArticle}>
      <Header title="Q&A" />
      {!isAuthorized ? (
        <div>
          <form className={styles.Form} onSubmit={handleSubmit}>
            <div className={styles.Label}>비밀번호를 입력하세요</div>
            <input
              type="password"
              name="pw"
              placeholder="****"
              autoComplete="new-password"
              onChange={handleInputPw}
              onKeyDown={handleKeyPress}
            ></input>

            <button type="submit">확인</button>
          </form>
        </div>
      ) : (
        <QnaInquiry data={data} />
      )}
      <LinkBtn to="/support/qna/articles" title="목록" />
    </div>
  );
}
